import React from "react";
import { Form } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import { Tooltip } from "../../utils/components/Tooltip";
import { InputError } from './InputError';

export const InputGebietsansaessiger = (props = {}) => {
  const {
    name, className, validate, placeholder, label, labelClass, inputClass, required, ...attributes
  } = props;

  const requiredStar = required ? "*" : "";
  return (
    <Form.Group className="field row pb-1">
      <Form.Label className={labelClass}>
        {label}{requiredStar}
      </Form.Label>
      <Field
        name={name}
        className={className}
        validate={validate}
        required={required}
      >
        {({ input, meta }) => {
          return (
            <>
              <Form.Group className={"col-12 col-md-7 col-lg-7" + (meta && meta.touched && meta.error ? " is-invalid" : "")}>
                <Form.Select
                  {...input}
                  aria-label={label}
                  {...attributes}
                  size="lg"
                  isInvalid={meta && meta.touched && meta.error}
                  isValid={meta && meta.touched && !meta.error}
                >
                  <option value="none">Bitte auswählen</option>
                  <option value="0">Nein</option>
                  <option value="1">Ja</option>
                </Form.Select>
              </Form.Group>
              <div className="col-12 col-lg-1 mt-1 pt-1 d-flex d-lg-block">
                <Tooltip>Natürliche Personen mit Wohnsitz oder gewöhnlichem Aufenthaltsort in Deutschland.</Tooltip>
                <p className="ms-1 f-small d-lg-none">Natürliche Personen mit Wohnsitz oder gewöhnlichem Aufenthaltsort in Deutschland.
                </p>
              </div>
              <InputError meta={meta} />
            </>
          );
        }}
      </Field >
    </Form.Group >
  );
};
